<template>
  <router-link class="footer-item-container p-2 mt-2" :to="{ name: routeName }" @click.native="recordNavigation(routeName)">
    <font-awesome-icon :icon="icon" class="footer-item-icon mx-auto"></font-awesome-icon>
    <p class="footer-item-title">{{ title }}</p>
    <slot></slot>
  </router-link>
</template>

<script>
import eventTracking from '@/mixins/event-tracking';

export default {
  name: 'FooterItem',
  mixins: [eventTracking],
  props: {
    icon: Array,
    title: String,
    routeName: String,
  },
};
</script>

<style lang="scss" scoped src="./styles.scss">

</style>
